import { useMemo } from 'react';
import { FormSection } from 'redux-form';
import PropTypes from 'prop-types';

import { zones as zonesService } from 'services/zones';
import { ZonesTabs } from '../blocks/zones-tabs';
import { WeekdayTariffication } from './weekday-tariffication';
import { Content } from './weekday.styled';

export const TarrificatorWeekday = (props) => {
  const { selectedZone, setZone, disabled } = props;
  const zones = useMemo(() => zonesService.getZones(), []);

  const getTabs = () => {
    if (!selectedZone) {
      return null;
    }

    return zones.map((zone) => {
      return (
        <FormSection key={zone.id} name={zone.id}>
          <WeekdayTariffication color={zone.background_color} display={selectedZone === zone.id} name={zone.id} disabled={disabled} />
        </FormSection>
      );
    });
  };

  return (
    <Content>
      <ZonesTabs setZone={setZone} activeZone={selectedZone} />
      {getTabs()}
    </Content>
  );
};

TarrificatorWeekday.propTypes = {
  selectedZone: PropTypes.any,
  setZone: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
